<template>
  <v-app light id="inspire">
    <v-slide-y-transition mode="out-in">
      <router-view class="view"></router-view>
    </v-slide-y-transition>
    
  </v-app>
</template>

<script>
  import Portada from './components/Portada.vue'
  export default {
    data: () => ({}),
    components: {
      'portada-component': Portada,
    },
  }
</script>



// WEBPACK FOOTER //
// src/App.vue